module.exports = __webpack_public_path__ + "img/drive-viewer-panel-2.94d09a13.svg";